<template>
  <div class="data-box component">
    <SpinnerWave v-if="loading" class="spinner-wrapper"></SpinnerWave>

    <div v-if="!isEmpty && !error" :class="{ 'data-box-content': true, loading: loading }">
      <slot></slot>
    </div>

    <div v-if="isEmpty && !error && !loading" class="data-box-content is-empty">
      <div class="title">No content!</div>
    </div>

    <div v-if="error" class="data-box-content error">
      <div class="title">Что-то пошло не так!</div>
      <div class="error-msg">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import SpinnerWave from './progress-loaders/UiSpinnerWave.vue'

export default {
  name: 'DataBox',
  components: { SpinnerWave },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
    error: {
      type: [String, Boolean],
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
.data-box.component {
  position: relative;
  width: 100%;
  height: 100%;
  .data-box-content {
    height: 100%;
  }
  .data-box-content.loading {
    min-height: 200px;
    pointer-events: none;
    opacity: 0.3;
  }
  .spinner-wrapper {
    position: absolute;
  }

  .is-empty,
  .error {
    padding: 30px;
    font-size: 16px;
    text-align: center;
    .title {
      font-size: 20px;
    }
  }

  .error {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: $red;

    .error-msg {
      padding-top: 10px;
    }
  }
}
</style>

<style>
.swal2-close {
  font-size: 1.5em;
  box-shadow: none;
}
</style>
